<!--
 * @LastEditors: zhanglinju
-->
<template>
  <div id="content">
    <div class="content-left">
      <div
        class="all"
        :class="catalogId ? '' : 'active'"
        @click="selectAll"
      >
        站点栏目
      </div>
      <el-tree
        class="column-tree min-scrollbar"
        :data="treeList"
        :props="defaultProps"
        :highlight-current="highlight"
        :default-expand-all="true"
        :expand-on-click-node="false"
        @node-click="handleNodeClick"
      />
      <div class="menu-button">
        <el-button
          class="plainBtn"
          size="small"
          @click="showColumn"
        >
          维护栏目
        </el-button>
      </div>
    </div>
    <div class="content-right">
      <div class="listHead">
        <div>
          <div class="sCircle" />
          <span style="font-size:16px;font-weight:700">{{ name }}</span>
        </div>
        <div />
      </div>
      <div
        class="layout-cont-box"
      >
        <the-condition
          multiple="identity"
          :limit="selectResult"
          @limit-change="init(1)"
        >
          <tr
            key="else"
            class="tab-row"
          >
            <td
              class="tab-cell tab-label"
              style="width: 120px;"
            >
              <span style="top:3px;position:relative;">输入搜索</span>
            </td>
            <td colspan="2">
              <el-input
                v-model="searchInput"
                style="margin-right:12px;"
                class="tab-ipt"
                size="small"
                autocomplete="off"
                placeholder="请输入标题或关键字进行搜索"
                @keyup.enter.native="init(1)"
              />
              <el-button
                type="primary"
                size="small"
                @click="init(1)"
              >
                搜索
              </el-button>
            </td>
            <td />
          </tr>
        </the-condition>
      </div>
      <div
        class="listHead"
        style="margin-top: 12px;"
      >
        <div class="table-title">
          <div class="sCircle" />
          <span style="font-size: 16px;font-weight: 700; color: #A0A0A0;">
            <span
              v-for="(node, index) in nodeList"
              :key="index"
              class="node"
            ><span
              v-if="index > 0"
              class="symbol"
            > > </span>{{ node.name }}</span>
          </span>
        </div>
        <div>
          <el-checkbox
            v-model="isAlone"
            @change="changeCheck"
          >
            只看当前栏目内容
          </el-checkbox>
          <el-button
            class="plainBtn"
            size="small"
            @click="addContent('','new')"
          >
            添加内容
          </el-button>
        </div>
      </div>
      <div style="padding:16px 24px;background-color:#fff;">
        <el-table
          v-if="tableData.length > 0"
          :data="tableData"
          border
          :header-cell-style="headCss"
          style="width:100%;"
        >
          <el-table-column
            prop="contentId"
            label="ID"
            align="center"
            width="100"
          />
          <el-table-column
            prop="rank"
            label="排序"
            align="center"
            width="100"
          />
          <el-table-column
            label="封面图"
            align="center"
            width="130"
          >
            <template slot-scope="{row}">
              <img
                :src="row.imageUrl"
                style="width: 100px; max-height: 100px;"
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="title"
            label="名称"
            align="center"
          >
            <template slot-scope="{row}">
              <a
                href="javascript:;"
                class="title"
                @click="addContent(row.contentId)"
              >{{ row.title }}</a>
            </template>
          </el-table-column>
          <el-table-column
            prop="updateTime"
            label="更新时间"
            align="center"
            width="200"
          />
          <el-table-column
            prop="publishStatus"
            label="发布状态"
            align="center"
            width="200"
          >
            <template slot-scope="{row}">
              {{ publishStatusMap[row.publishStatus] }}
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            label="链接状态"
            align="center"
            width="124"
          >
            <template slot-scope="{row}">
              {{ row.status === 0 ? '禁用' : '启用' }}
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            width="180"
          >
            <template slot-scope="{row}">
              <div class="icon-list">
                <mix-tooltip
                  :enterable="false"
                  content="复制内容"
                  popper-class="user-table-tooltip weight"
                  placement="top"
                  effect="light"
                >
                  <i
                    class="icon icon-clone"
                    @click="copyContent(row)"
                  />
                </mix-tooltip>
                <mix-tooltip
                  :enterable="false"
                  content="复制链接"
                  popper-class="user-table-tooltip weight"
                  placement="top"
                  effect="light"
                >
                  <i
                    class="icon icon-copy"
                    @click="copyToClipboard(row.contentId)"
                  />
                </mix-tooltip>
                <mix-tooltip
                  v-if="row.status == 1"
                  :enterable="false"
                  content="禁用"
                  popper-class="user-table-tooltip weight islocked"
                  placement="top"
                  effect="light"
                >
                  <i
                    class="icon icon-disabled"
                    @click="changeStatus(row)"
                  />
                </mix-tooltip>
                <mix-tooltip
                  v-else
                  :enterable="false"
                  content="启用"
                  popper-class="user-table-tooltip weight"
                  placement="top"
                  effect="light"
                >
                  <i
                    class="icon icon-useable"
                    @click="changeStatus(row)"
                  />
                </mix-tooltip>
                <br>
                <mix-tooltip
                  :enterable="false"
                  content="上移"
                  popper-class="user-table-tooltip weight"
                  placement="top"
                  effect="light"
                >
                  <i
                    class="icon icon-up"
                    @click="changeRank(row, -1)"
                  />
                </mix-tooltip>
                <mix-tooltip
                  :enterable="false"
                  content="下移"
                  popper-class="user-table-tooltip weight"
                  placement="top"
                  effect="light"
                >
                  <i
                    class="icon icon-down"
                    @click="changeRank(row, 1)"
                  />
                </mix-tooltip>
                <mix-tooltip
                  :enterable="false"
                  content="删除"
                  popper-class="user-table-tooltip weight"
                  placement="top"
                  effect="light"
                >
                  <i
                    class="icon icon-delete"
                    @click="remove(row)"
                  />
                </mix-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div
          v-else
          style="width:100%;text-align:center;color:#aaa;"
        >
          <img src="../../../../assets/image/no_data.png">
        </div>
      </div>
      <el-pagination
        v-show="pagination.total > 0"
        background
        :page-sizes="pageSizes"
        :page-size.sync="pagination.size"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="pagination.current"
        :total="pagination.total"
        @current-change="currentChange"
        @size-change="sizeChange"
      />
    </div>
  </div>
</template>
<script>
import api from './proxy';
import TheCondition from '../../../common/TheCondition';
import { pageSizes } from '@/lib/utils';

export default {
    name: 'ContentManage',
    components: { TheCondition },
    data () {
        return {
            highlight: false,
            tableData: [],
            treeList: [],
            selectResult: {},
            searchInput: '',
            catalogId: 0,
            nodeList: [], // 选择栏目的所有上级节点列表
            treeMutationList: [],
            pagination: {
                total: 0,
                current: 1,
                size: 10,
            },
            pageSizes,
            headCss: { 'background-color': '#F1FFFA' }, // 表头样式
            publishStatusMap: {
                0: '未发布-草稿',
                1: '已发布',
                2: '已修改-草稿',
            },
            defaultProps: {
                children: 'children',
                label: 'name',
            },
            isAlone: false,
        };
    },
    computed: {
        siteId () {
            return this.$route.query.siteId || (this.$store.getters['system/getSiteList'].length > 0 ? this.$store.getters['system/getSiteList'][0].siteId : null);
        },
        name () {
            return this.$route.query.name || (this.$store.getters['system/getSiteList'].length > 0 ? this.$store.getters['system/getSiteList'][0].name : '');
        },
    },
    created () {
        localStorage.setItem('saveUpdate', '');
        console.log('created siteId===============');
        console.log(this.siteId);
        if (!this.siteId) return this.$router.replace({ name: 'pageDetail', query: { client: 'back' } });
        this.getPageList();
        this.getTreeList();
        window.onstorage = () => {
            if (localStorage.getItem('saveUpdate') === '1') {
                localStorage.setItem('saveUpdate', '');
                this.pagination.current = 1;
                this.getPageList();
            }
        };
        // this.getWebSiteMsg();
    },
    destroyed () {
        window.onstorage = null;
    },
    methods: {
        getTreeList () {
            api.getTreeList({ siteId: this.siteId, isShowDisable: 0 }).then(res => {
                if (res.errcode === 0) {
                    this.treeList = res.data.value.catalogList;
                    const all = {
                        catalogId: 0,
                        name: '站点栏目',
                        pCatalogId: null,
                        type: '0',
                        image: '',
                        describe: '',
                        catalogLink: '',
                        rank: 0,
                        status: 0,
                        children: [],
                    };
                    all.children = res.data.value.catalogList;
                    this.treeMutationList = this.getList([all]);
                    this.getNodeList(this.catalogId);
                }
            });
        },
        changeCheck () {
            this.getPageList();
        },
        // 获取站点模板信息
        getWebSiteMsg () {
            let params = {
                siteId: this.siteId,
            };
            api.websiteInfo(params).then(res => {
                if (res.errcode === 0) {
                    console.log(res);
                } else {
                    this.$message.error(res.errmsg);
                }
            });
        },
        selectAll () {
            this.highlight = false;
            this.catalogId = 0;
            this.init();
        },
        handleNodeClick (node) {
            this.highlight = true;
            // if (node.children.length === 0) {
            this.catalogId = node.catalogId;
            this.init();
            // }
        },
        showDetail () {},
        init (data) {
            this.pagination.current = 1;
            this.nodeList = [];
            this.getNodeList(this.catalogId);
            this.getPageList();
        },
        // 供使用者调用
        trim (s) {
            return this.trimRight(this.trimLeft(s));
        },
        // 去掉左边的空白
        trimLeft (s) {
            if (s == null) {
                return '';
            }
            var whitespace = new String(' \t\n\r');
            var str = new String(s);
            if (whitespace.indexOf(str.charAt(0)) != -1) {
                var j = 0, i = str.length;
                while (j < i && whitespace.indexOf(str.charAt(j)) != -1) {
                    j++;
                }
                str = str.substring(j, i);
            }
            return str;
        },

        trimRight (s) {
            if (s == null) return '';
            var whitespace = new String(' \t\n\r');
            var str = new String(s);
            if (whitespace.indexOf(str.charAt(str.length - 1)) != -1) {
                var i = str.length - 1;
                while (i >= 0 && whitespace.indexOf(str.charAt(i)) != -1) {
                    i--;
                }
                str = str.substring(0, i + 1);
            }
            return str;
        },
        getPageList () {
            const params = {
                siteId: this.siteId,
                catalogId: this.catalogId || null,
                keyWord: this.trim(this.searchInput).toString(),
                pageNo: this.pagination.current,
                pageSize: this.pagination.size,
                current: this.isAlone ? 1 : 0,

            };
            api.getPageList(params).then(res => {
                if (res.errcode === 0) {
                    this.pagination.total = res.data.totalCount;
                    this.tableData = res.data.list;
                }
            });
        },
        getList (list, result = []) {
            if (list.length > 0) {
                list.forEach(item => {
                    result.push(item);
                    if (item.children.length > 0) this.getList(item.children, result);
                });
            }
            return result;
        },
        // 获取所有上级节点
        getNodeList (catalogId) {
            console.log('getNodeList===================');
            console.log(catalogId);
            console.log(this.treeMutationList);
            let node = this.treeMutationList.find(node => node.catalogId === catalogId);
            if (node) {
                this.nodeList.unshift(node);
                if (node.pCatalogId !== null) this.getNodeList(node.pCatalogId);
            }
        },
        // 复制内容
        copyContent (data) {
            console.log(data);
            api.copyContent({ contentId: data.contentId }).then(res => {
                if (res.errcode === 0) this.init();
            });
        },
        // 启用/禁用
        changeStatus (data) {
            this.$confirm(data.status === 0 ? '启用内容后，该内容将可进行正常访问，确认启用？' : '禁用内容后，该内容将无法再进行访问，请谨慎操作。确认禁用？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                api.changeContentStatus({ contentId: data.contentId, status: data.status === 0 ? 1 : 0 }).then(res => {
                    if (res.errcode === 0) {
                        if (data.status === 0) {
                            data.status = 1;
                            this.$message.success('启用成功');
                        } else {
                            data.status = 0;
                            this.$message.success('停用成功');
                        }
                    }
                });
            }).catch(() => {
            });
        },
        // 上移/下移
        changeRank (data, operation) {
            console.log();
            api.changeRank({ siteId: this.siteId, contentId: data.contentId, operation, catalogId: data.catalogId || this.catalogId === 0 ? '' : this.catalogId, current: this.isAlone ? 1 : 0 }).then(res => {
                if (res.errcode === 0) {
                    this.getPageList();
                }
            });
        },
        remove (data) {
            this.$confirm('确认删除该内容？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                api.remove([data.contentId]).then(res => {
                    if (res.errcode === 0) {
                        this.init();
                        this.$message.success('删除成功');
                    }
                });
            }).catch(() => {
            });
        },
        currentChange (p) {
            this.pagination.current = p;
            this.getPageList();
        },
        sizeChange (p) {
            this.pagination.size = p;
            this.init();
        },
        preview () {
            this.$router.push({ name: 'mobileModules' });
        },
        addContent (contentId, isnew) {
            let sort = this.tableData[0] && this.tableData[0].rank ? this.tableData[0].rank : 1;
            let url = this.$router.resolve({ name: 'make', query: { contentId, catalogId: this.catalogId, siteId: this.siteId, name: this.name, sort, isnew } });
            window.open(url.href, '_blank');
        },
        showColumn () {
            this.$router.push({ name: 'column', query: { client: this.$route.query.client, siteId: this.siteId, name: this.name, stack: Number(this.$route.query.stack) - 1 } });
        },

        copyToClipboard (contentId) {
            // if()
            let siteMsg = JSON.parse(sessionStorage.getItem('websiteMsg'));
            let url = '';
            if (siteMsg && siteMsg.webTemplate) {
                url = this.$router.resolve({ name: 'webModulePage', query: { contentId, siteId: siteMsg.id } });
            } else {
                url = this.$router.resolve({ name: 'mobileContent', query: { contentId } });
            }
            let text = window.location.origin + window.location.pathname + url.href;
            // if(text.indexOf('-') !== -1) {
            //     let arr = text.split('-');
            //     text = arr[0] + arr[1];
            // }
            console.log(text);
            var textArea = document.createElement('textarea');
            textArea.style.position = 'fixed';
            textArea.style.top = '0';
            textArea.style.left = '0';
            textArea.style.width = '2em';
            textArea.style.height = '2em';
            textArea.style.padding = '0';
            textArea.style.border = 'none';
            textArea.style.outline = 'none';
            textArea.style.boxShadow = 'none';
            textArea.style.background = 'transparent';
            textArea.value = text;
            document.body.appendChild(textArea);
            textArea.select();
            try {
                var successful = document.execCommand('copy');
                var msg = successful ? '成功复制到剪贴板' : '该浏览器不支持点击复制到剪贴板';
                if (successful) {
                    this.$message.success(msg);
                } else {
                    this.$message.warning(msg);
                }
            } catch (err) {
                this.$message.warning('该浏览器不支持点击复制到剪贴板');
            }
            document.body.removeChild(textArea);
        },
    },
};
</script>

<style scoped lang="scss">
#content {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    .content-left {
        flex-shrink: 0;
        width: 224px;
        overflow: auto;
        .el-tree {
            max-height: calc(100vh - 280px);
            overflow-y: auto;
        }
        .all {
            padding-left: 50px;
            line-height: 44px;
            color: #999;
            border-right: 2px solid #2ED095;
            background-image: url('../../../../assets/icon/icon_all.png');
            background-color: #E6FFF5;
            background-size: 12px;
            background-repeat: no-repeat;
            background-position: 27px center;
            cursor: pointer;
            &.active {
                color: #2ED095;
                background-image: url('../../../../assets/icon/icon_all_active.png');
            }
        }
        .menu-button {
            line-height: 88px;
            text-align: center;
            background: #FFF;
            .el-button {
                border-color: #2ED095 !important;
                color: #2ED095;
            }
        }
    }
    .content-right {
        flex-grow: 1;
        width: calc(100% - 234px);
        margin-left: 10px;
        .layout-cont-box {
            background: #FFF;
            .tab-row .el-input {
                width: 280px;
                margin-right: 10px;
            }
        }
        .listHead {
            margin-top: 0;
            padding: 10px 30px 10px 24px;
            width: 100%;
            // height: 53px;
            // line-height: 53px;
            line-height: 1.6;
            background-color: #fff;
            border-bottom: 1px solid #eee;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .table-title {
                padding-right: 30px;
            }
        }
        .sCircle {
            margin-bottom: 2px;
            margin-right: 10px;
            display: inline-block;
            border: 2px solid #ccc;
            width: 10px;
            height: 10px;
            border-radius: 50%;
        }
        .plainBtn {
            border-color: #2ED095 !important;
            color: #2ED095;
        }
        .title {
            color: #2ED095;
        }
        .icon-list {
            padding-right: 20px;
            .icon {
                margin-top: 20px;
                margin-left: 20px;
                // padding: 0 15px;
                display: inline-block;
                width: 14px;
                height: 14px;
                background-size: cover;
                background-repeat: no-repeat;
                background-position: center;
                outline: none;
                cursor: pointer;
                &.icon-clone {
                    background-image: url("../../../../assets/icon/icon_clone_unactive.png");
                    &:hover {
                        background-image: url("../../../../assets/icon/icon_clone.png");
                    }
                }
                &.icon-copy {
                        background-image: url("../../../../assets/icon/icon_copy_unactive.png");
                    &:hover {
                        background-image: url("../../../../assets/icon/icon_copy.png");
                    }
                }
                &.icon-disabled {
                    background-image: url("../../../../assets/icon/icon_disabled_unactive.png");
                    &:hover {
                        background-image: url("../../../../assets/icon/icon_disabled.png");
                    }
                }
                &.icon-useable {
                    background-image: url("../../../../assets/icon/icon_useable_unactive.png");
                    &:hover {
                        background-image: url("../../../../assets/icon/icon_useable.png");
                    }
                }
                &.icon-up {
                    background-image: url("../../../../assets/icon/icon_up_unactive.png");
                    &:hover {
                        background-image: url("../../../../assets/icon/icon_up.png");
                    }
                }
                &.icon-down {
                    background-image: url("../../../../assets/icon/icon_down_unactive.png");
                    &:hover {
                        background-image: url("../../../../assets/icon/icon_down.png");
                    }
                }
                &.icon-delete {
                    background-image: url("../../../../assets/icon/icon_delete_unactive.png");
                    &:hover {
                        background-image: url("../../../../assets/icon/icon_delete.png");
                    }
                }
            }
        }
    }
}
</style>
<style lang="scss">
#content {
    .el-tree {
        padding-bottom: 30px;
        overflow-x: auto;
        & > div {
            width: 300px;
        }
    }
}
</style>
